import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
    prout = 'protal';
} else {
    prout = 'protal_' + Language;
}


// 活动-获取地区数据，洲-国家-省-市
export async function getactivityGetArea(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity/getArea", params);
    } catch (error) {
        return error;
    }
}

// 活动-列表

export async function getactivityList(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity/index", params);
    } catch (error) {
        return error;
    }
}

// 活动详情

export async function getactivityInfo(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity/info", params);
    } catch (error) {
        return error;
    }
}

// download/downAnnex
// export async function getdownloaddownAnnex(id) {
//     try {
//         return await API.get("/api/download/downAnnex", {
//             params: {
//                 id,
//             },
//         });
//     } catch (error) {
//         return error;
//     }
// }

// 活动-详情-资料下载（下载用的）
export async function getdownloaddownAnnex(params) {
    try {
        return await API.get("/api/" + prout + "/download/downAnnex", {
            params,
            responseType: "blob",
        });
    } catch (error) {
        return error;
    }
}

// 活动详情-问题研讨
export async function getactQuestion(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity_que/actQuestion", params);
    } catch (error) {
        return error;
    }
}

// 问题点赞
export async function getactQuestionLike(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity_que/actQuestionLike", params);
    } catch (error) {
        return error;
    }
}

// 收藏activity/collection
export async function setCollection(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity/collection", params);
    } catch (error) {
        return error;
    }
}


// activity_que/actQuestionAdd
//活动详情-问题研讨-回答/回复

export async function setactQuestionAdd(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity_que/actQuestionAdd", params);
    } catch (error) {
        return error;
    }
}


// 立即报名  activity/signUp
export async function setSignUp(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity/signUp", params);
    } catch (error) {
        return error;
    }
}

// 日历  activity/activityCalendar

export async function getactivityCalendar(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity/activityCalendar", params);
    } catch (error) {
        return error;
    }
}

// 添加文章

export async function setArticleAdd(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/articleAdd", params);
    } catch (error) {
        return error;
    }
}

// 取消报名
export async function setCancelSignUp(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity/cancelSignUp", params);
    } catch (error) {
        return error;
    }
}


// 活动点赞
export async function setActivitylike(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity/like", params);
    } catch (error) {
        return error;
    }
}

export async function getActivityCommonData(params) {
    try {
        return await API.post("/api/" + prout + "/api/activity/commonData", params);
    } catch (error) {
        return error;
    }
}